<template>
  <div class="ct-card rounded-xl overflow-hidden">
    <div class="px-5 py-4">
      <div v-if="title || $slots.header" class="flex items-center gap-2" :class="headerMargin">
        <h2 class="text-[12px] font-bold uppercase tracking-[0.06em]" :class="titleClass">
          {{ title }}
        </h2>
        <slot name="header" />
      </div>
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
withDefaults(defineProps<{
  title?: string
  /** Bottom margin class for the header row. Defaults to 'mb-3'. */
  headerMargin?: string
  /** Extra classes applied to the title h2 (e.g. 'text-foreground/40' for ghost cards). */
  titleClass?: string
}>(), {
  headerMargin: 'mb-3',
  titleClass: 'text-foreground',
})
</script>

<style scoped>
.ct-card {
  background: var(--card);
  border: 1px solid rgba(0, 0, 0, 0.06);
  box-shadow:
    0 1px 2px rgba(0, 0, 0, 0.03),
    0 4px 12px rgba(0, 0, 0, 0.05);
}
:is(.dark *).ct-card {
  border: 1px solid rgba(255, 255, 255, 0.08);
  box-shadow:
    0 1px 2px rgba(0, 0, 0, 0.2),
    0 4px 12px rgba(0, 0, 0, 0.3);
}
</style>
